import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCultures.success: {
            return action.payload.results;
        }

        case constants.clearCultures.toString(): {
            return initialState;
        }

        default:
            return state;
    }
}
